import React, { useState, useRef, useEffect } from 'react';
import { DollarSign, ChevronDown } from 'lucide-react';
import { useTranslation } from '../context/TranslationContext';

function CurrencySwitcher() {
  const { currency, setCurrency, currencies } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const currentCurrency = currencies[currency];

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1.5 px-2.5 py-2 text-sm text-neutral-400 hover:text-white transition-colors rounded-lg hover:bg-white/5"
        data-testid="currency-switcher"
        aria-label="Select currency"
      >
        <DollarSign className="w-4 h-4" />
        <span className="font-medium">{currency}</span>
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 top-full mt-2 w-48 bg-neutral-900 border border-white/10 rounded-xl shadow-xl overflow-hidden z-50">
          <div className="px-3 py-2 border-b border-white/10">
            <p className="text-xs text-neutral-500 uppercase tracking-wide">Select Currency</p>
          </div>
          {Object.entries(currencies).map(([code, config]) => (
            <button
              key={code}
              onClick={() => {
                setCurrency(code);
                setIsOpen(false);
              }}
              className={`w-full flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
                code === currency
                  ? 'bg-[#d4af37]/10 text-[#d4af37]'
                  : 'text-neutral-300 hover:bg-white/5 hover:text-white'
              }`}
              data-testid={`currency-${code}`}
            >
              <span className="text-base">{config.flag}</span>
              <span className="flex-1 text-left">
                <span className="font-medium">{code}</span>
                <span className="text-xs text-neutral-500 ml-2">{config.symbol}</span>
              </span>
              {code === currency && (
                <span className="text-[#d4af37]">✓</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default CurrencySwitcher;
